import { makeAutoObservable, runInAction } from 'mobx';

import { client } from 'contexts/ApolloClient/apolloClient';
import { standardError } from 'global/commonMessages';
import { notificationStore } from 'global/NotificationStore';
import { FETCH_ACTION_LOG } from 'pages/RideDetails/gql/fetchActionLog';
import { sortByDateUsingTimestamp } from 'utils/datetime';

import { buildActionLogChunks } from './buildActionLogChunks';

class ActionLogStore {
	actions = [];
	isLoading = true;
	isError = false;

	constructor() {
		makeAutoObservable(this);
	}

	fetchActionLog = async (rideId) => {
		this.isLoading = true;
		try {
			const response = await client.query({
				query: FETCH_ACTION_LOG,
				fetchPolicy: 'no-cache',
				variables: {
					rideId,
				},
			});
			const dataActions = [...response.data.getWorkAssignmentActionLogByRideId];
			dataActions.sort((actionA, actionB) => {
				return sortByDateUsingTimestamp(actionB.createdAt, actionA.createdAt);
			});
			if (dataActions.length === 0) {
				this.isLoading = false;
				return;
			}
			const result = buildActionLogChunks(dataActions);
			runInAction(() => {
				this.actions = result;
				this.isLoading = false;
			});
		} catch {
			this.isLoading = false;
			notificationStore.setNotification(standardError);
		}
	};
}

export const actionLogStore = new ActionLogStore();
export { ActionLogStore };
